<div class="content-container">
  <app-menu></app-menu>
  <mat-card class="novo-card">
    <mat-card-title class="novo-titulo">
      <div style="text-align: center;">
      <h2>Novo tópico</h2>
    </div>
    </mat-card-title>

    <mat-card-subtitle>
      Crie um tópico com sua dúvida e todos no evento poderão te ajudar :D
    </mat-card-subtitle>

    <mat-card-content>

      <mat-form-field style="width: 100%;">
        <input matInput placeholder="Diga-nos, com o que você precisa de ajuda?" [(ngModel)]="topico">
      </mat-form-field>

      <mat-form-field style="width: 100%;">
        <textarea matInput placeholder="Nos explique melhor por aqui" [(ngModel)]="duvida"></textarea>
      </mat-form-field>

    </mat-card-content>

    <button mat-flat-button
      [ngStyle]="{'margin': '8px'}"
      (click)="criarQuestao()">Criar tópico</button>
  </mat-card>

</div>
